function isFutureDataDisabled(): boolean {
  return process.env.REACT_APP_DISABLE_FUTURE_DATA === 'true';
}

export default isFutureDataDisabled;
